import React, { useCallback, useEffect, useState } from 'react';
import { Spin, Typography } from 'antd';
import { AssigneeModel } from '@/typings/models/Assignee';
import { fetchCalendarViewCalendarEvents, fetchCalendarViewServiceRequests } from '@/services/api/serviceRequest';
import { EntityViewServiceRequestList } from '@/components/Lead/LeadDetailsServiceRequests';
import { useHasAccess } from '@/utils/hooks';
import PERMISSIONS from '@/constants/permissions';

const { Text } = Typography;

interface AgentAppointmentsTabProps {
  agent: AssigneeModel;
}

const AgentAppointmentsTab: React.FC<AgentAppointmentsTabProps> = ({ agent }) => {
  const [appointments, setAppointments] = useState([]);
  const [loading, setLoading] = useState(false);
  const canViewCalendarEvents = useHasAccess([PERMISSIONS.CalendarEvents.VIEW]);

  const fetchAppointments = useCallback(() => {
    if (!agent?.id) return;

    setLoading(true);
    // Only fetch calendar events when the user can view them, otherwise the
    // request 403s and surfaces an error to the user.
    Promise.all([
      fetchCalendarViewServiceRequests({
        query: {
          assignee: agent.id,
          page_size: 250,
          with: 'agent'
        }
      }),
      canViewCalendarEvents
        ? fetchCalendarViewCalendarEvents({
            query: {
              assignee: agent.id,
              page_size: 250,
              with: 'agent'
            }
          })
        : Promise.resolve(null)
    ]).then(([ServiceRequestsResponse, CalendarEventsResponse]) => {
      const serviceRequests = ServiceRequestsResponse?.data?.data;
      const calendarEvents = CalendarEventsResponse?.data?.data;
      const allEvents = (serviceRequests || []).concat((calendarEvents || [] as any).map(event => ({
        ...event,
        blocker: true
      })));
      setLoading(false)
      setAppointments(allEvents);
    });
  }, [agent?.id, canViewCalendarEvents]);

  useEffect(() => {
    fetchAppointments();
  }, [fetchAppointments]);

  return (
      <Spin spinning={loading}>
        <EntityViewServiceRequestList request={fetchAppointments} events={appointments} addDisabled/>
      </Spin>
  );
};

export default AgentAppointmentsTab;
